<div class="add-container">
    <div class="d-flex justify-content-between align-items-center">
        <h1 class="add-title m-0 p-0">Info - Entitate</h1>
        <button class="action-buttons-side" (click)="closeDialog()">x</button>
    </div>
    <br />
    <mat-divider></mat-divider>
    <br />
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Direcție/Instituție</strong></h4>
        <p class="col-md-6">
            {{ data.directie_name ? data.directie_name : "n/a" }}
        </p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Compartiment/Departament</strong></h4>
        <p class="col-md-6">
            {{
            data.compartiment_name ? data.compartiment_name : "n/a"
            }}
        </p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Denumire</strong></h4>
        <p class="col-md-6">
            {{ data.denumire ? data.denumire : "n/a" }}
        </p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Persoană de contact</strong></h4>
        <p class="col-md-6">{{ data.pers_contact ? data.pers_contact : "n/a" }}</p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Tip persoană</strong></h4>
        <p class="col-md-6">{{ data.tip_adresa ? data.tip_adresa : "n/a" }}</p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Observații</strong></h4>
        <p class="col-md-6">{{ data.observatii ? data.observatii : "n/a" }}</p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Județ</strong></h4>
        <p class="col-md-6">{{ data.name_judet ? data.name_judet : "n/a" }}</p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Adresa</strong></h4>
        <p class="col-md-6">
            {{('Țară: ' + (data.name_tara ?
            data.name_tara : 'n/a') + ', ') +
            ('Jud: ' + (data.name_judet ? data.name_judet :
            'n/a') + ', ') +
            ('Oraș: ' + (data.name_localitate ? data.name_localitate :
            'n/a') + ', ') +
            ('Sect: ' + (data.sector && data.sector != '-1' ? data.sector :
            'n/a') + ', ') +
            ('Stradă: ' + (data.name_strada ?data.name_strada :
            'n/a') + ', ') +
            ('Nr: ' + (data.numar ? data.numar :
            'n/a') + ', ') +
            ('Bl: ' + (data.bloc ? data.bloc :
            'n/a') + ', ') +
            ('Sc: ' + (data.scara ? data.scara :
            'n/a') + ', ') +
            ('Et: ' + (data.etaj ? data.etaj :
            'n/a') + ', ') +
            ('Ap: ' + (data.apartament ? data.apartament :
            'n/a') + ', ') +
            ('CP: ' + (data.cod_postal ? data.cod_postal :
            'n/a'))}}
        </p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Email</strong></h4>
        <p class="col-md-6">{{ data.email ? data.email : "n/a" }}</p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Telefon</strong></h4>
        <p class="col-md-6">{{ data.telefon ? data.telefon : "n/a" }}</p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>CNP/CUI</strong></h4>
        <p class="col-md-6">{{data.cnp_cui ? data.cnp_cui : "n/a" }}</p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Status</strong></h4>
        <p class="col-md-6">{{data.active === 0 ? "Inactiv" : "Activ" }}</p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Public view</strong></h4>
        <p class="col-md-6">{{data.public_view === 0 ? "Inactiv" : "Activ" }}</p>
    </div>

    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">Vă rugăm așteptați!</h3>
        </div>
    </div>
</div>